import React, { useEffect, useState } from "react";
import Loader from "../../../../DefaultStyles/Loader";
import {
  LoginCheckMainWeb,
  getNowUseSystemLoginCheckWeb,
} from "../../../../../ApiTS/ApiLoginCheckWebTS";
import { GetSplitMyPartyAccInfo } from "../../../../../ApiTS/ApiCommonTS";
import { decryptPW } from "../../../../../Api/ApiCommon";
import AlertModal from "../../../../Modal/AlertModal";
import { useApi } from "../../../../../hooks/useApi";
import { toast } from "react-toastify";
import ContentLoader from "../../../../DefaultStyles/ContentLoader";
import { GetSubscriptionSetData } from "../../../../../ApiTS/ServiceDatasTS";
import ReportPartyValidCheckResultModal from "./ReportPartyValidCheckResultModal";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

interface ReportPartyValidCheckBtnProps {
  loginInfo: {
    shareid: string;
    password: string;
  };
  partyInfo: {
    id: number;
    ownerId: number;
    subsId: number;
    partyId: number;
  };
  prevResult: {
    login: boolean;
    membership: boolean;
    secondaryAuth: boolean;
  };
  refreshEvent: () => void;
}

let mountCount = 1;

export default function ReportPartyValidCheckBtn({
  partyInfo,
  loginInfo,
  prevResult,
  refreshEvent,
}: ReportPartyValidCheckBtnProps) {
  const [didMount, setDidMount] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [resultModal, setResultModal] = useState(false);
  const [checkResult, setCheckResult] = useState({
    isValid: false,
    hasMembership: false,
    needCheck: false,
    addInfo: "",
  });
  const [deleteRow, setDeleteRow] = useState(false);
  const [sendKakao, setSendKakao] = useState(false);
  const [askAlimtalkModal, setAskAlimtalkModal] = useState(false);
  const [deleteRowNoticeModal, setDeleteRowNoticeModal] = useState(false);

  // 신고 파티리스트에서 삭제 & 알림톡 자동 발송
  const { response, loading, error } = useApi({
    method: "delete",
    url: deleteRow ? `temp-account/delErrParty/${partyInfo?.id}` : undefined,
    data: {
      sendkakao: sendKakao ? 1 : 0, // 0: 안보냄, 1: 자동 발송
      alart_msg: " ",
    },
  });

  console.log(checkResult);

  // 로그인 체크 실행
  const checkAccount = async () => {
    setIsLoading(true);

    const id = GetSplitMyPartyAccInfo(loginInfo?.shareid)?.id ?? "";
    const idType = GetSplitMyPartyAccInfo(loginInfo?.shareid)?.idType ?? "";
    const pw = decryptPW(
      String(loginInfo?.password ?? ""),
      String(partyInfo?.ownerId ?? 0)
    )?.pw;

    const { isValid, hasMembership, needCheck, addInfo } =
      await LoginCheckMainWeb(
        partyInfo?.subsId,
        id?.replace(/(\s*)/g, ""),
        pw,
        idType
      );

    console.log(isValid, hasMembership);

    setTimeout(() => {
      setCheckResult({
        isValid,
        hasMembership,
        needCheck,
        addInfo,
      });

      setResultModal(true);

      setIsLoading(false);
    }, 1500);
  };

  useEffect(() => {
    if (response?.status === 200) {
      setDeleteRow(false);
      toast.success(
        response?.data?.result < 0
          ? "신고 파티리스트에서 삭제하였습니다."
          : `신고 파티리스트에서 삭제 후 ${response?.data?.result}명에게 알림톡 보내기에 성공했습니다.`
      );
      if (response?.data?.result === -1) {
        toast.error("진행 중인 파티가 아니라 알림톡이 발송되지 않았습니다.");
      }
      refreshEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      setDeleteRow(false);

      toast.error(
        error?.data ?? "신고 파티리스트에서 삭제하는 데에 실패하였습니다."
      );
    }
  }, [error]);

  const checkIsUsingLoginCheck = async () => {
    const isUsingLoginCheck = await getNowUseSystemLoginCheckWeb(
      partyInfo?.subsId ?? 0
    );

    if (isUsingLoginCheck) {
      console.log("check account!");

      checkAccount();
    } else {
      console.log("로그인 체크를 지원하지 않는 idtype인 경우");
    }
  };

  useEffect(() => {
    console.log("mount: ", mountCount);
    mountCount++;
    setDidMount(true);
    console.log("check btn");

    return () => {
      console.log("unmount");
    };
  }, []);

  useEffect(() => {
    console.log("didMount: ", didMount);
    if (didMount) {
      console.log("api 호출");
      checkIsUsingLoginCheck();
    }
  }, [didMount]);

  return (
    <>
      {isLoading && (
        <ContentLoader
          title={`${partyInfo?.subsId}_${getSubsNameBySubsId3(
            partyInfo?.subsId ?? 0
          )} ${partyInfo?.partyId} 파티의
    유효성 체크를 진행합니다.`}
        />
      )}

      {loading && <Loader />}

      {/* 로그인 체크 결과 모달 */}
      {resultModal && (
        <ReportPartyValidCheckResultModal
          partyId={partyInfo?.partyId}
          checkResult={checkResult}
          confirmEvent={() => {
            const isValid = checkResult?.isValid && checkResult?.hasMembership;

            if (!isValid) {
              refreshEvent();
            } else {
              setAskAlimtalkModal(true);
              setResultModal(false);
            }
          }}
          closeEvent={() => setResultModal(false)}
        />
      )}

      {/* 이용권 체크 성공 => 알림톡 발송 여부 선택 */}
      {askAlimtalkModal && (
        <AlertModal
          title={`파티원에게 파티 정상화 알림톡을 전송하시겠습니까?`}
          confirmText="확인"
          cancelEvent={() => {
            setAskAlimtalkModal(false);
            setDeleteRowNoticeModal(true);
          }}
          confirmEvent={() => {
            setSendKakao(true);
            setDeleteRowNoticeModal(true);
            setAskAlimtalkModal(false);
          }}
        />
      )}

      {/* 로그인 체크 성공 => 리스트에서 삭제 통지 모달 */}
      {deleteRowNoticeModal && (
        <AlertModal
          title={
            sendKakao
              ? `파티원에게 파티 정상화 알림이 전송되며,
          신고된 파티 리스트에서 해당 파티가 삭제됩니다.`
              : `파티가 정상화 되었습니다.
          신고된 파티 리스트에서 해당 파티가 삭제됩니다.`
          }
          btnColor="mint"
          customCancelBtn={<></>}
          confirmText="확인"
          confirmEvent={() => {
            setDeleteRowNoticeModal(false);
            setDeleteRow(true);
          }}
        />
      )}
    </>
  );
}
